import React, { useContext } from "react";
import { useQuery } from "@apollo/client";
import { Link } from "react-router-dom";
import {
  Breadcrumb,
  Header,
  Loader,
  Card,
  Message,
  Icon,
} from "semantic-ui-react";
import StudentCard from "../components/StudentCard";
import { LIST_PARENT_STUDENTS } from "../GraphQL";
import UserContext from "contexts/UserContext";

const ParentHome = () => {
  const user = useContext(UserContext);
  const { loading, error, data } = useQuery(LIST_PARENT_STUDENTS);

  if (loading) {
    return <Loader />;
  }
  if (error) {
    throw error;
  }

  const showProfileMessage = user.getAttributes().name === undefined;
  const profileMessage = (
    <Message info icon>
      <Icon name="user circle" />
      <Message.Content>
        <Message.Header>Update your profile</Message.Header>
        Howdy, stranger! Why don't you tell us your{" "}
        <Link to="/settings">name</Link>, and maybe your{" "}
        <Link to="/settings">phone number</Link> to receive text alerts when new
        reports are available.
      </Message.Content>
    </Message>
  );

  return (
    <div>
      <Breadcrumb size="tiny">
        <Breadcrumb.Section>
          <Link to="/">Home</Link>
        </Breadcrumb.Section>
      </Breadcrumb>
      {showProfileMessage ? profileMessage : null}
      <Header as="h2" dividing>
        My Children
      </Header>
      <Card.Group>
        {data.myProfile.children.map((student, i) => (
          <StudentCard key={i} student={student} showTeacher />
        ))}
      </Card.Group>
    </div>
  );
};

export default ParentHome;
